<template lang="pug">
	img(
		src="http://7xlsgk.com2.z0.glb.qiniucdn.com/2qi148025184379643.jpg"
		@click="click()"
	)
</template>
<script>
	const axios = require('axios').create()

	module.exports = {
		mounted () {
			axios.get('https://test.qiang7.cn/api/extra/ads/cb58c45856d54d71/focus')
		},
		methods: {
			click () {
				axios.get('https://test.qiang7.cn/api/extra/ads/c9a59d1ac51e3bcc/focus/track')
			}
		}
	}
</script>



// WEBPACK FOOTER //
// a.vue?4880a053